(() => {
  if (window.bpBundleItems) return;
  const setup = () => document.querySelectorAll('.bp-bundle').forEach(bundle => {
    if (bundle.dataset.coloursReady) return;
    bundle.dataset.coloursReady = 'true';
    const info = bundle.closest('product-info');
    if (!info) return;
    const photos = JSON.parse(info.querySelector('[data-bp-bundle-images]').textContent);
    const slots = [...bundle.querySelectorAll('[data-bp-bundle-slot]')];
    const count = () => Number(bundle.querySelector('input:checked').value);
    const sync = () => {
      const total = count();
      if (total === 1) {
        const current = info.querySelector('variant-selects input:checked,variant-selects select')?.value;
        const first = slots[0].querySelector('select');
        const option = [...first.options].find(option => option.dataset.title === current);
        if (option) first.value = option.value;
      }
      bundle.querySelector('.bp-bundle__choices').hidden = total === 1;
      slots.forEach((slot, index) => {
        slot.hidden = index >= total;
        const option = slot.querySelector('select').selectedOptions[0];
        slot.querySelector('img').src = photos[option.dataset.title];
      });
      bundle.querySelectorAll('.bp-bundle__pictures').forEach(pictures => {
        [...pictures.querySelectorAll('img')].forEach((img, index) => {
          const option = slots[index].querySelector('select').selectedOptions[0];
          img.removeAttribute('srcset');
          img.src = photos[option.dataset.title];
        });
      });
      info.querySelectorAll('.shopify-payment-button').forEach(button => button.hidden = total > 1);
      const quantity = info.querySelector('.product-form__quantity');
      if (quantity) quantity.hidden = false;
    };
    bundle.addEventListener('change', sync);
    info.addEventListener('change', event => {
      if (!event.target.closest('variant-selects')) return;
      const selected = [...info.querySelectorAll('variant-selects input:checked,variant-selects select')].map(input => input.value);
      slots.forEach((slot, index) => {
        const select = slot.querySelector('select');
        const option = [...select.options].find(option => selected.includes(option.dataset.title));
        if (option && (index === 0 || !select.dataset.customColour)) select.value = option.value;
      });
      sync();
    });
    slots.forEach(slot => slot.querySelector('select').addEventListener('change', event => event.target.dataset.customColour = 'true'));
    sync();
    new MutationObserver(sync).observe(info, { childList: true, subtree: true });
  });
  window.bpBundleItems = form => {
    const bundle = form.closest('product-info')?.querySelector('.bp-bundle');
    if (!bundle) return null;
    const count = Number(bundle.querySelector('input:checked').value);
    if (count === 1) return null;
    const grouped = new Map();
    [...bundle.querySelectorAll('[data-bp-bundle-colour]')].slice(0, count).forEach(select => grouped.set(select.value, (grouped.get(select.value) || 0) + 1));
    return [...grouped].map(([id, quantity]) => ({ id, quantity }));
  };
  document.addEventListener('DOMContentLoaded', setup);
  document.addEventListener('shopify:section:load', setup);
  new MutationObserver(setup).observe(document.documentElement, { childList: true, subtree: true });
  setup();
})();